let lastId = localStorage.getItem("lastId") || 0;
export default function(prefix = "id") {
  lastId++;
  localStorage.setItem("lastId", lastId);
  return `${prefix}${lastId}`;
}
